export default "__VITE_ASSET__DweAah7B__"